<template>
  <b-row align-content="center" class="pt-3">
    <b-col>
      <b-nav class="nav-tabs nav-overflow header-tabs">
        <slot />
      </b-nav>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'HeaderNav'
}
</script>
